/**
 * @param  {HTMLDivElement} el
 * @param  {} options
 */
const MandatoryLimitTimer = (el, options) => {
  const defaults = {
    updateTime: 1000,
    showSeconds: false,
    serverDate: false,
  }

  const params = Object.assign({}, defaults, options)

  const lastTimeObj = {}
  /**
   * @param  {HTMLSpanElement} secondsNode
   * @param  {HTMLSpanElement} minutesNode
   * @param  {HTMLSpanElement} separatorNode
   */
  let secondsNode
  let minutesNode
  let currentTimeObj
  let timeout
  let limitValue
  let syncTime

  const init = () => {
    el.innerHTML =
      '' +
      '<div class="limit-clock-icon"><svg height="16" width="16" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fill-opacity=".9" fill-rule="evenodd"><path d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"/><path d="M10.5 5H9v6l5.2 3.2.8-1.3-4.5-2.7V5z"/></g></svg></div>' +
      '<span id="clockMinutes">00</span>' +
      '<span id="clockSeparator" class="clock-separator">:</span>' +
      '<span id="clockSecundes">00</span>'

    minutesNode = el.querySelector('#clockMinutes')
    secondsNode = el.querySelector('#clockSecundes')

    setLimitValue(params.mandatoryLimitValue)
    render()

    el.className = el.className.replace('hidden', '')
  }

  const update = () => {
    clearTimeout(timeout)
    render()
    timeout = setTimeout(update, params.updateTime)
  }

  const render = () => {
    currentTimeObj = getTimeString()

    if (lastTimeObj.minutes !== currentTimeObj.minutes) {
      minutesNode.innerHTML = currentTimeObj.minutes
      lastTimeObj.minutes = currentTimeObj.minutes
    }

    if (lastTimeObj.seconds !== currentTimeObj.seconds) {
      secondsNode.innerHTML = currentTimeObj.seconds
      lastTimeObj.seconds = currentTimeObj.seconds
    }
  }

  const updateSyncTime = () => {
    syncTime = Math.floor(new Date().getTime() / 1000)
  }

  const setLimitValue = (val) => {
    limitValue = val
    updateSyncTime()
  }

  const prettyTimeString = (num) => (num < 10 ? '0' : '') + num

  const getTimeString = () => {
    const d = Math.floor(new Date().getTime() / 1000)
    const ddif = limitValue + d - syncTime
    const minutes = Math.floor(ddif / 60)
    const seconds = Math.floor(ddif) % 60

    return {
      minutes: prettyTimeString(minutes),
      seconds: prettyTimeString(seconds),
    }
  }

  init()

  return { el, setLimitValue, update, updateSyncTime }
}

module.exports = MandatoryLimitTimer
